import { Col, Descriptions, Row } from 'antd';
import Sorefsis from 'components/sorefsis';
import SorefsisChart from 'pages/mainForms/mainForm/components/basicInfoBeneficiary/components/sorefsisChart';
import React from 'react';
import { printInfo } from 'store/appTrack/utils';
import { ReactComponent as GreenChevron } from '../../../../../assets/icons/green-chevron.svg';
import { ReactComponent as Recycle1 } from '../../../../../assets/icons/recycle-icon1.svg';
import { ReactComponent as Recycle2 } from '../../../../../assets/icons/recycle-icon2.svg';
import { ReactComponent as Recycle3 } from '../../../../../assets/icons/recycle-icon3.svg';
import { useSelector } from 'react-redux';

const BasicInfo = () => { 

  const apptrackDetails = useSelector(state=>state.appTrack.apptrackDetails);

  const response = Object.keys(apptrackDetails?.variablesIndexed).length === 1 && apptrackDetails?.variablesIndexed.hasOwnProperty('initiator') ? apptrackDetails?.localTaskVariables : apptrackDetails?.variablesIndexed;
  console.log("response:",response);
  return (
    <Row className=''>
      <Col span={12}>
      
      <div style={{marginBottom:"2rem", marginTop:"2rem"}}>
        <span className='basic-form-title'>Στοιχεία Αίτησης</span>
      </div>
        <Descriptions
          // title="Βασικά Στοιχεία Επιχείρησης"
          bordered
          className="large-titles-purple-responsive investment-plan-details-table"
          style={{marginRight:"6%"}}
          column={1}
        >
          <Descriptions.Item label="ΑΦΜ Επιχείρησης">
            {printInfo(response.abiVat)}
          </Descriptions.Item>
          <Descriptions.Item label="Επωνυμία Επιχείρησης">
            {printInfo(response.companyName)}
          </Descriptions.Item>
          <Descriptions.Item label="Ημ. Σύστασης">
            {printInfo(response.regDate)}
          </Descriptions.Item>
          <Descriptions.Item label="Νομική Μορφή">
            {printInfo(response.companyLegalType)}
          </Descriptions.Item>
          <Descriptions.Item label="ΚΑΔ Κύριας Δραστηριότητας">
            {printInfo(response.mainKAD + ' - ' + response.mainKADDescription)}
          </Descriptions.Item>
          <Descriptions.Item label="Περιοχή">
            {printInfo(response.abiDistrict)}
          </Descriptions.Item>
          <Descriptions.Item label="Νομός">
            {printInfo(response.abiPerfecture)}
          </Descriptions.Item>
          <Descriptions.Item label="Οδός - ΤΚ">
            {printInfo(response.abiStreetFull) + ' - ' + printInfo(response?.abiTk)}
          </Descriptions.Item>
          <Descriptions.Item label="Τηλέφωνο">
            {printInfo(response.invMob)}
          </Descriptions.Item>
          <Descriptions.Item label="Email">
            {printInfo(response.invMail)}
          </Descriptions.Item>
        </Descriptions>
        </Col>
        <Col span={12} style={{marginBottom:"2rem", marginTop:"2rem"}} > 
      
        <div style={{display:"inline-grid", width:"100%", alignContent:"space-between"}}>
          <Descriptions
            title="Νόμιμος Εκπρόσωπος"
            bordered
            className="large-titles-purple descriptions-table-graye"
            column={1}
          >
            <Descriptions.Item label="Ονοματεπώνυμο">
              {printInfo(response.legalSurname)} {printInfo(response.legalName)}
            </Descriptions.Item>
            <Descriptions.Item label="Τηλέφωνο Επικοινωνίας">
              {printInfo(response.legalPhone)}
            </Descriptions.Item>
            <Descriptions.Item label="E-mail Επικοινωνίας">
              {printInfo(response.legalEmail)}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions
            title="Υπεύθυνος Επικοινωνίας"
            bordered
            className="large-titles-purple descriptions-table-graye"
            column={1}
          >
            <Descriptions.Item label="Ονοματεπώνυμο">
              {printInfo(response.contactPersonFlag ? response.legalSurname : response.contactSurname)} {printInfo(response.contactPersonFlag ? response.legalName : response.contactName)}
            </Descriptions.Item>
            <Descriptions.Item label="Τηλέφωνο Επικοινωνίας">
              {printInfo(response.contactPersonFlag ? response.legalPhone : response.contactPhone)}
            </Descriptions.Item>
            <Descriptions.Item label="E-mail Επικοινωνίας">
              {printInfo(response.contactPersonFlag ? response.legalEmail : response.contactEmail)}
            </Descriptions.Item>
          </Descriptions>
        </div>
        </Col>

      {/* <Row
        gutter={{ xs: 0, sm: 2, md: 5, lg: 10 }}
        className="carrier-data-form__row mt-6 sorefsis"
      >
        <Col span={16} className="sorefsis-col-1">
          <>
            <Sorefsis></Sorefsis>
          </>
        
        </Col>
        <Col span={8} className="sorefsis-col-2">
          <div className="carrier-data-form mt-3">
            <SorefsisChart realValue={response.totalAmountSorefsis ? response.totalAmountSorefsis : 0} 
            limit={response?.mainKAD?.startsWith("01") ? process.env.REACT_APP_SOREFSIS_AMOUNT_KAD_01 : process.env.REACT_APP_SOREFSIS_AMOUNT }/>
          </div>
        </Col>
      </Row> */}
    </Row>
    
  );
};

export default BasicInfo;